//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


  import ResultImg  from './components/resultCommon/resultImg'
  import Slots  from './components/resultCommon/slots'
  import Banner  from './components/resultCommon/banner'

  import Poster from '@/components/poster/poster'

import { Share,CacheModule } from '@/utils/commonUtils'

  export default {
    data() {
      return {
        no:0,
        posterList:[
          'https://static.soyoung.com/sy-pre/prod0-1596701768210.png',
          'https://static.soyoung.com/sy-pre/prod1-1596701768210.png',
          'https://static.soyoung.com/sy-pre/prod2-1596701768210.png',
          'https://static.soyoung.com/sy-pre/prod3-1596701768210.png',
        ],
        poserText:'长按图片保存  邀请好友一起玩',
        posterImg:'',
      }
    },
    created() {
      this.no = CacheModule.get('riskGamesNum').toString() || '0';
      this.posterImg = this.posterList[this.no]
      if(this.CHANNAL_ID == "APP"){
        this.poserText = ''
      }
      // if(process.env.VUE_APP_CURRENTMODE === 'production'){
      //   this.posterList = [
      //     'https://static.soyoung.com/sy-pre/prod0-1596701768210.png',
      //     'https://static.soyoung.com/sy-pre/prod1-1596701768210.png',
      //     'https://static.soyoung.com/sy-pre/prod2-1596701768210.png',
      //     'https://static.soyoung.com/sy-pre/prod3-1596701768210.png',
      //   ]
      // }

    },
    mounted () {
      let obj ={
          'shareTitle':'瘦脸针避坑挑战Come on！',
          'shareContent':  '想要小V脸、一字肩？闯关答题还能赢MAC口红哦~',
          'shareTimelineContent':'瘦脸针避坑挑战Come on！',
          'shareUrl': `https://${window.location.host}/riskGames?activityId=game&from_action=game_url`,
          'shareImgurl': 'https://static.soyoung.com/sy-pre/shareicon-1596528600703.png',
          'rightBtnStatus': 1
      }
      Share(obj,'sybao_ins_activity_share_result_sys',obj);

      this.STATISTICS('load','sybao_ins_activity_end_page');
      
    },
    components: {
      ResultImg,
      Slots,
      Banner,
      Poster
    },
    methods: {
      inviteClick(){
        this.STATISTICS('click','sybao_ins_game_share_click');

        this.$refs.posterRef.show();
        this.STATISTICS('click','sybao_ins_game_report_exposure',{'question_id':this.no});

      }
    },
  }
